import React, { useState, useEffect } from 'react';
import { TextField } from '@rmwc/textfield';
import '@rmwc/textfield/styles';
import { Radio } from '@rmwc/radio';
import '@rmwc/radio/styles';
import { Slider } from '@rmwc/slider';
import '@rmwc/slider/styles';
import { RCTooltip } from '@rmwc/rc-tooltip';
import '@rmwc/rc-tooltip/styles';
import { useFlexionStore } from '../Stores';
import { getText } from '../Helpers';
import './DataSelect.css';
import EinStarr from '../assets/EinStarr.png';
import ZweiAuf from '../assets/ZweiAuf.png';
import ZweiStarr from '../assets/ZweiStarr.png';

function DataSelect() {
  const Länge = useFlexionStore((state) => state.Länge);
  const setLänge = useFlexionStore((state) => state.setLänge);
  const Punktlast = useFlexionStore((state) => state.Punktlast);
  const setPunktlast = useFlexionStore((state) => state.setPunktlast);
  const Streckenlast = useFlexionStore((state) => state.Streckenlast);
  const setStreckenlast = useFlexionStore((state) => state.setStreckenlast);
  const GewDurchbiegung = useFlexionStore((state) => state.GewDurchbiegung);
  const setGewDurchbiegung = useFlexionStore((state) => state.setGewDurchbiegung);
  const Sprache = useFlexionStore((state) => state.Sprache);
  const RadioVal = useFlexionStore((state) => state.Radio);
  const setRadio = useFlexionStore((state) => state.setRadio);
  const SliderVal = useFlexionStore((state) => state.Slider);
  const setSlider = useFlexionStore((state) => state.setSlider);

  const [text, settext] = useState(getText(Sprache));

  function handleLänge(e) {
    if (e.target.value > 99999) {
      setLänge(Länge);
    } else setLänge(e.target.value);
  }

  useEffect(() => {
    settext(getText(Sprache));
  }, [Sprache]);

  return (
    <>
      <RCTooltip
        open={parseFloat(Länge, 10) < 0}
        showArrow
        align='bottom'
        content={text.DataSelect.LessThan0Tooltip}
      >
        <TextField
          label={text.DataSelect.LInput}
          type='number'
          value={Länge}
          onChange={handleLänge}
          onFocus={(e) => {
            e.target.select();
          }}
          className='Input'
        />
      </RCTooltip>
      <RCTooltip
        open={parseFloat(Punktlast, 10) < 0}
        showArrow
        align='bottom'
        content={text.DataSelect.LessThan0Tooltip}
      >
        <TextField
          label={text.DataSelect.PInput}
          type='number'
          value={Punktlast}
          onChange={(e) => setPunktlast(e.target.value)}
          onFocus={(e) => {
            e.target.select();
          }}
          className='Input'
        />
      </RCTooltip>
      <RCTooltip
        open={parseFloat(Streckenlast, 10) < 0}
        showArrow
        align='bottom'
        content={text.DataSelect.LessThan0Tooltip}
      >
        <TextField
          label={text.DataSelect.SInput}
          type='number'
          value={Streckenlast}
          onChange={(e) => setStreckenlast(e.target.value)}
          onFocus={(e) => {
            e.target.select();
          }}
          className='Input'
        />
      </RCTooltip>

      <RCTooltip
        open={GewDurchbiegung === '' || parseInt(GewDurchbiegung, 10) === 0}
        showArrow
        align='bottom'
        className='VorTool'
        content={text.DataSelect.ValidToolTip}
      >
        <TextField
          label={text.DataSelect.DBInput}
          value={GewDurchbiegung}
          onChange={(e) => setGewDurchbiegung(e.target.value)}
          type='number'
          step='any'
          onFocus={(e) => {
            e.target.select();
          }}
          className={GewDurchbiegung === '' ? 'MaxDubiNoValue Input' : 'Input'}
        />
      </RCTooltip>
      <table>
        <tbody>
          <tr>
            <td>
              <Radio
                checked={RadioVal === 'Einseitig'}
                value='Einseitig'
                name='Option'
                onChange={(e) => setRadio(e.target.value)}
              />
            </td>
            <td>
              <img src={EinStarr} alt='' />
            </td>
            <td />
          </tr>
          <tr>
            <td>
              <Radio
                checked={RadioVal === 'Zweiseitig'}
                value='Zweiseitig'
                name='Option'
                onChange={(e) => setRadio(e.target.value)}
              />
            </td>
            <td>
              <img src={ZweiAuf} alt='' />
            </td>
            <td>
              <img src={ZweiStarr} alt='' />
            </td>
          </tr>
          <tr className={RadioVal === 'Einseitig' ? 'hidden' : ''}>
            <td colSpan='3'>
              <Slider
                discrete
                min={0}
                max={100}
                step={5}
                onChange={(e) => setSlider(e.target.value)}
                value={SliderVal}
                onInput={(e) => setSlider(e.target.value)}
              />
            </td>
          </tr>
          <tr className={RadioVal === 'Einseitig' ? 'hidden' : ''}>
            <td colSpan='3'>{text.DataSelect.FirstHelpText}</td>
          </tr>
          <tr className={RadioVal === 'Einseitig' ? 'hidden' : ''}>
            <td colSpan='3'>{text.DataSelect.SecondHelpText}</td>
          </tr>
          <tr className={RadioVal === 'Einseitig' ? 'hidden' : ''}>
            <td colSpan='3'>{text.DataSelect.ThirdHelpText}</td>
          </tr>
        </tbody>
      </table>
    </>
  );
}

export default DataSelect;
